import React, { Component } from 'react'
import s from './styles.scss'
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import moment from 'moment'

const QUERY = gql`
query Request($uuid: String) {
  request(_id: $uuid) {
    id
    _id
    tutor_price
    parent_price
    sofia_price
  }
}
`

const UPDATE = gql`
mutation updateRequest($input: requestMutation) {
  updateRequest(input: $input) {
    state
    id
    _id
  }
}
`

class RequestDetails extends Component {

  render() {

    if (!this.props.uuid) return null

    return <Query
      query={QUERY}
      variables={{
        uuid: this.props.uuid
      }}
      >
      {({ loading, error, data, fetchMore }) => {
      if (loading) return null;
      if (error) {
        console.error(error)
        return <p>Error :(</p>
      };

      const { tutor_price, parent_price, sofia_price } = data.request
   
      return <div className={s.container}>

        <div className="box">
          <h3>Price</h3>

          <Mutation mutation={UPDATE}>
            {(updateRequest, { data }) => (
                <input type="number" className="small" defaultValue={parent_price} placeholder="parent_price" onChange={e => updateRequest({ variables: { input: { _id: this.props.uuid, parent_price: e.target.value } } })} />
            )}
          </Mutation>
          <br />
          <Mutation mutation={UPDATE}>
            {(updateRequest, { data }) => (
                <input type="number" className="small" defaultValue={tutor_price} placeholder="tutor_price" onChange={e => updateRequest({ variables: { input: { _id: this.props.uuid, tutor_price: e.target.value } } })} />
            )}
          </Mutation>
          <br />
          <Mutation mutation={UPDATE}>
            {(updateRequest, { data }) => (
                <input type="number" className="small" defaultValue={sofia_price} placeholder="tutor_price" onChange={e => updateRequest({ variables: { input: { _id: this.props.uuid, sofia_price: e.target.value } } })} />
            )}
          </Mutation>
          
        </div>

      </div>

      }}
  </Query>
  }
}

export default RequestDetails;



// WEBPACK FOOTER //
// ./src/containers/requests/Details/tabs/payment.js